import { Input, Label, Select } from '@iwoca/orion';
import { msg } from '@lingui/core/macro';
import { useLingui } from '@lingui/react/macro';
import { clsx } from 'clsx';
import { useFormContext } from 'react-hook-form';

import styles from './FullNameField.module.css';
import { useLocale } from '../../../../../hooks/useLocale';
import { TPersonalDetailsDataDE } from '../../PersonalDetailsDE';

export const TITLES = [
  { value: 'herr', label: msg`Man` },
  { value: 'frau', label: msg`Woman` },
] as const;

const FullNameField = () => {
  const { i18n } = useLocale();
  const { t } = useLingui();

  const {
    register,
    formState: { errors },
  } = useFormContext<TPersonalDetailsDataDE>();

  return (
    <div>
      <Label>Name</Label>
      <div className={styles.fullNameContainer}>
        <Select
          {...register('title')}
          placeholder={t`Title`}
          data-testid="title"
          className={clsx({
            [styles.erroredSelect]: errors.title?.message,
          })}
          error={errors.title?.message}
        >
          {TITLES.map((option) => (
            <option key={option.value} value={option.value}>
              {i18n._(option.label)}
            </option>
          ))}
        </Select>
        <Input
          {...register('firstName')}
          placeholder={t`First name`}
          data-testid="first-name"
          error={errors.firstName?.message}
          className="fs-mask"
        />
        <Input
          {...register('lastName')}
          placeholder={t`Last name`}
          data-testid="last-name"
          error={errors.lastName?.message}
          className="fs-mask"
        />
      </div>
    </div>
  );
};

export default FullNameField;
